import { type BookmarkAttributes } from './generated/BookmarkAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import CardLayout from './CardLayout';
import { model } from '../modelBuilder';
import { HasBookmarkSidebarSettings } from './concerns/HasBookmarkSidebarSettings';

interface Bookmark extends BookmarkAttributes, HasBookmarkSidebarSettings {}

@model
@HasBookmarkSidebarSettings
class Bookmark extends ApplicationModel {
  // Start auto-generated
  static typename: 'Bookmark' = 'Bookmark';
  get typename(): 'Bookmark' {
    return 'Bookmark';
  }

  static internalTypename: 'Publish::Bookmark' = 'Publish::Bookmark';
  get internalTypename(): 'Publish::Bookmark' {
    return 'Publish::Bookmark';
  }

  static inputType = 'BookmarkAttributes!';

  static fields = {
    createdAt: attr({ readable: true }),
    filters: attr({ writable: true, readable: true, json: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    showCollapsedView: attr({ writable: true, readable: true }),
    sidebarSettings: attr({ writable: true, readable: true, json: true }),
    updatedAt: attr({ readable: true }),
    cardLayout: attr.belongsTo({
      writeShape: [
        'epicRecordLayout',
        'featureRecordLayout',
        'ideaRecordLayout',
        'initiativeRecordLayout',
        'releaseRecordLayout',
        'releasePhaseRecordLayout',
        'requirementRecordLayout',
        'taskRecordLayout',
        'goalRecordLayout',
      ],
      readable: true,
      typename: 'CardLayout',
    }),
    defaultCardLayout: attr.belongsTo({
      readable: true,
      typename: 'CardLayout',
    }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
  };
  // End auto-generated

  get activeCardLayout() {
    const { cardLayout, defaultCardLayout } = this;
    if (!cardLayout || !defaultCardLayout) return;

    return CardLayout.buildActiveCardLayout({ cardLayout, defaultCardLayout });
  }
}

export default Bookmark;
